
import GroupsAx    from 'app/actions/groups';
import {
  SocialFeedTypes,
}                  from 'app/constants';
import SocialDuck  from 'app/ducks/social';
import RoutingSlx  from 'app/selectors/routing';

const Types = {
  LOAD: 'PAGE_GROUP_LOAD',
};

const Actions = {

  load: ({params, path}) => (dispatch, getState) => {
    // skip when page is already loaded
    const prevPath = RoutingSlx.path(getState());
    if (prevPath === path) return;

    const groupId = params.id;

    const promise = Promise.all([
      dispatch(GroupsAx.get(groupId)),
      dispatch(GroupsAx.getMembership()),
      dispatch(SocialDuck.Ax.listingsSearch({feedType: SocialFeedTypes.GROUP, feedId: groupId, limit: 12})),
    ]);
    return dispatch({type: Types.LOAD, promise, groupId});
  },
};

export {
  Types,
};

export default Actions;
